import { combineReducers } from 'redux'
import { AccountCategoriesAppState, AccountsAppState } from 'interfaces/accounts'
import { createFilterCategoryReducer, createTimeframeReducer, createTrendModeReducer } from 'reducers/globalReducer'

export const assetsApp = combineReducers<AccountsAppState>({
  timeframe: createTimeframeReducer('assets'),
  trendMode: createTrendModeReducer('assets'),
  categories: combineReducers<AccountCategoriesAppState>({
    selectedId: createFilterCategoryReducer('assets'),
  }),
})

export const debtsApp = combineReducers<AccountsAppState>({
  timeframe: createTimeframeReducer('debts'),
  trendMode: createTrendModeReducer('debts'),
  categories: combineReducers<AccountCategoriesAppState>({
    selectedId: createFilterCategoryReducer('debts'),
  }),
})
